import { Component, Input } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-youtube-embeder',
    templateUrl: './youTubeEmbeder.component.html',
    styleUrls: ['./youTubeEmbeder.component.scss']
})

export class YouTubeEmbederComponent {

    @Input('videoIframeUrl') videoIframeUrl: string = null;
    @Input('height') height: number = null;
    @Input('width') width: number = null;

    version: string = environment.version;
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/youTubeEmbeder/youTubeEmbeder.component.ts